import { SET_LOCATION_FOR_DEALER_SUGGESTIONS } from "./types";

export const setLocationMessageForDealerSuggestions = (locationMessage) => (
  dispatch
) => {
  dispatch({
    type: SET_LOCATION_FOR_DEALER_SUGGESTIONS,
    payload: locationMessage,
  });
};
